import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/data/content";

export const Footer = ({ onStartProject }) => {
    return (
        <footer
            className="relative border-t border-black/10 bg-[hsl(var(--bg-2))]"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-7xl container-px py-16 lg:py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-5">
                        <Link to="/" className="inline-flex">
                            <img
                                src={BRAND.logoUrl}
                                alt="IdeaClap"
                                className="h-28 w-28 sm:h-32 sm:w-32 object-contain"
                            />
                        </Link>
                        <p className="mt-6 max-w-md text-[15px] leading-relaxed text-[hsl(var(--text-muted))] font-display italic">
                            “Creative + Marketing, powered by AI Agents and Human Talent.”
                        </p>
                        <button
                            type="button"
                            onClick={onStartProject}
                            data-testid="footer-start-project-button"
                            className="sheen group mt-7 inline-flex items-center gap-2 rounded-full bg-[hsl(var(--text))] hover:bg-[hsl(var(--text))]/90 text-[hsl(var(--bg))] px-5 py-2.5 text-sm font-semibold transition-colors"
                        >
                            Start a Project
                            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </button>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--text-subtle))] font-mono">
                            Explore
                        </div>
                        <ul className="mt-5 space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        className="text-[hsl(var(--text-muted))] hover:text-[hsl(var(--text))] text-[15px] transition-colors"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <div className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--text-subtle))] font-mono">
                            Headquarters
                        </div>
                        <ul className="mt-5 space-y-3 text-[15px] text-[hsl(var(--text-muted))]">
                            <li className="flex gap-3">
                                <MapPin className="h-4 w-4 mt-1 text-[hsl(var(--gold))] flex-none" />
                                <span data-testid="footer-address">
                                    {BRAND.contact.address}
                                </span>
                            </li>
                            <li className="flex gap-3">
                                <Mail className="h-4 w-4 mt-1 text-[hsl(var(--blue))] flex-none" />
                                <a
                                    href={`mailto:${BRAND.contact.email}`}
                                    className="hover:text-[hsl(var(--text))] transition-colors"
                                    data-testid="footer-email"
                                >
                                    {BRAND.contact.email}
                                </a>
                            </li>
                            <li className="flex gap-3">
                                <Phone className="h-4 w-4 mt-1 text-[hsl(var(--blue))] flex-none" />
                                <a
                                    href={`tel:${BRAND.contact.phone.replace(/[^\d+]/g, "")}`}
                                    className="hover:text-[hsl(var(--text))] transition-colors"
                                    data-testid="footer-phone"
                                >
                                    {BRAND.contact.phone}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-black/10 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between text-xs text-[hsl(var(--text-subtle))]">
                    <div>
                        © {new Date().getFullYear()} IdeaClap Global. All rights reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
